import { useContext } from "react";
import { AuthContext } from '../auth-context/context';
export const useUserContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
      throw new Error('useTheme must be used within a AuthProvider');
  }
  return context;
}

